import { getOsType } from './utils'
import store from '../store'
const isElectron = !!process.env.IS_ELECTRON

const trackEvent = (category, action, label, value) => {
  if (window._hmt) {
    const from = isElectron ? getOsType() : `web`
    const user = store.state.me
    const isPro = store.getters.is_pro
    const PRO_new_user = store.getters.PRO_new_user
    const membership_referral = {
      sidemenu: '侧边栏菜单',
      sidemenu_passcode: '侧边栏锁定',
      backlink: '反向链接',
      thread: '引用批注',
      tagicon_change: '更换图标',
      notify: '每日回顾',
      stat: '记录统计',
      notifications: '消息通知',
      pin_memo: '多条置顶',
      wechat_voice: '微信语音输入',
      account: '设置-基本信息',
      account_storage: '设置-原图上传',
      account_zen: '设置-禅定模式',
      account_passcode: '设置-密码锁',
      notion: '设置-同步Notion',
      incoming_webhook: '记录API',
      wechat_notice: '微信通知',
      wechat_notice_add_pro_days: '微信通知-奖励通知',
    }

    let valueStr = ''
    if (!category && !action) {
      return
    }

    if (user) {
      valueStr = `${isPro ? (PRO_new_user ? 'PRO新用户' : 'PRO用户') : '普通用户'}`
    }

    if (label) {
      valueStr = `${valueStr}-${membership_referral[label] || label}`
    }

    window._hmt.push(['_trackEvent', `${category}-${from}`, action, `${valueStr}`, value ? value : 0])
  }
}

export default trackEvent
